import { RouterProvider } from "@tanstack/react-router";
import { Provider } from "react-redux";
import { Toaster } from "sonner";

import { router } from "@/routes/appRoutes";
import { store } from "@/store";
import { GlobalPollingModal } from "@/components/organism/GlobalPollingModal/GlobalPollingModal";
import { useGlobalPollingModal } from "@/hooks/ui/useGlobalPollingModal";

function AppContent() {
  const { state: pollingState, handlers: pollingHandlers } = useGlobalPollingModal();

  return (
    <>
      <Toaster position="top-right" />
      <RouterProvider router={router} />
      <GlobalPollingModal
        isOpen={pollingState.isOpen}
        title={pollingState.title}
        message={pollingState.message}
        details={pollingState.details}
        onClose={pollingHandlers.handleClose}
      />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
